

//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types
export const OBTENER_OFICINAS_CEO = "obtenerOficinasCeo";
export const OBTENER_OFICINA_CE = "obtenerOficinaCeo";
// mutation types
export const SET_OFICINAS_CEO = "setOficinasCeo";
export const SET_OFICINA_CEO = "setOficinaCeo";

const state = {
    oficinasCeo: [],
    oficinaCeo:[],
}

const getters = {
    obtenerOficinasCeo(state) {
      return state.oficinasCeo;
    },
}

const actions = {
    async [OBTENER_OFICINAS_CEO](context, estadoId) {

        /*
        * Si el estado es null va a traer a todas las etnias, de lo contrario va a traer los etnias por estado
        *
        */
        let endpoint = 'api/Oficinas_CEO'
        if(estadoId){
            endpoint = `api/Oficinas_CEO/GetOficinas_CEOActivas/${estadoId}`
        }

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_OFICINAS_CEO, data.data);
                    //console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });       
    },

    

    async [OBTENER_OFICINA_CE](context, id){
        
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/Empresas/`)
                .then(({ data }) => {
                    context.commit(SET_OFICINA_CEO, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    


    }
  }

const mutations = {
    [SET_OFICINAS_CEO](state, data) {
        state.oficinasCeo = data;
    },

    [SET_OFICINA_CEO](state, data) {
        state.oficinaCeo = data;
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}